/* Pialú — Estimación de fecha de entrega (bloque PDP).
   Recalcula el rango en el cliente, en la zona horaria de la tienda
   (America/Lima por defecto), para que el caché de Shopify nunca muestre una
   fecha obsoleta. Ventana: del día +1 al día +3 tras la compra; se envía de
   lunes a sábado, así que los domingos se desplazan al lunes. */
(function () {
  'use strict';

  var MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var DEFAULT_TZ = 'America/Lima';

  // Componentes de fecha "hoy" en la zona horaria dada (o null si es inválida).
  function tzParts(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      var y, m, d;
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'year') y = +parts[i].value;
        else if (parts[i].type === 'month') m = +parts[i].value;
        else if (parts[i].type === 'day') d = +parts[i].value;
      }
      if (y && m && d) return { y: y, m: m, d: d };
    } catch (e) { /* zona horaria inválida */ }
    return null;
  }

  // "Hoy" como fecha de calendario (medianoche UTC) en la zona horaria dada.
  // Si la zona configurada es inválida (typo del comerciante) se reintenta con
  // America/Lima — NUNCA con el reloj local del visitante, salvo que Intl no
  // esté disponible en absoluto.
  function todayInTZ(tz) {
    var p = tzParts(tz) || (tz !== DEFAULT_TZ ? tzParts(DEFAULT_TZ) : null);
    if (p) return new Date(Date.UTC(p.y, p.m - 1, p.d));
    var n = new Date();
    return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()));
  }

  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setUTCDate(d.getUTCDate() + n);
    return d;
  }

  // Sin entregas en domingo (envío lun–sáb): domingo → lunes.
  function bumpSunday(date, deliverSunday) {
    if (deliverSunday) return date;
    return date.getUTCDay() === 0 ? addDays(date, 1) : date;
  }

  function compute(today, startOffset, endOffset, deliverSunday) {
    var start = bumpSunday(addDays(today, startOffset), deliverSunday);
    var end = bumpSunday(addDays(today, endOffset), deliverSunday);
    if (end.getTime() < start.getTime()) end = start;
    return { start: start, end: end };
  }

  function fmt(start, end) {
    var sd = start.getUTCDate(), sm = start.getUTCMonth(), sy = start.getUTCFullYear();
    var ed = end.getUTCDate(), em = end.getUTCMonth(), ey = end.getUTCFullYear();
    if (sm === em && sy === ey) {
      return { inicio: String(sd), fin: ed + ' de ' + MONTHS[em] };
    }
    return { inicio: sd + ' de ' + MONTHS[sm], fin: ed + ' de ' + MONTHS[em] };
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function render(el) {
    var tz = el.getAttribute('data-tz') || DEFAULT_TZ;
    var startOffset = parseInt(el.getAttribute('data-start-offset'), 10);
    var endOffset = parseInt(el.getAttribute('data-end-offset'), 10);
    var deliverSunday = el.getAttribute('data-deliver-sunday') === 'true';
    if (isNaN(startOffset) || startOffset < 0) startOffset = 1;
    if (isNaN(endOffset) || endOffset < 0) endOffset = 3;

    var r = compute(todayInTZ(tz), startOffset, endOffset, deliverSunday);
    var f = fmt(r.start, r.end);

    var tpl = el.getAttribute('data-template') ||
      'Ordena ahora y recibe tu pedido entre el [inicio] y el [fin]';
    var html = tpl
      .replace('[inicio]', '<strong>' + escapeHtml(f.inicio) + '</strong>')
      .replace('[fin]', '<strong>' + escapeHtml(f.fin) + '</strong>');

    var textEl = el.querySelector('[data-delivery-estimate-text]');
    if (textEl) textEl.innerHTML = html;
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-delivery-estimate]');
    for (var i = 0; i < nodes.length; i++) render(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
